export default "__VITE_ASSET__Qiv5Owcf__"